const UPPER = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const LOWER = 'abcdefghijklmnopqrstuvwxyz';
const DIGITS = '0123456789';
const SYMBOLS = '!@#$%&*?-_';
const ALL = UPPER + LOWER + DIGITS + SYMBOLS;
const MIN_LENGTH = 12;
const STRENGTH_LABELS = ['Muito fraca', 'Fraca', 'Razoável', 'Forte', 'Muito forte'];

function randomIndex(max) {
    const arr = new Uint32Array(1);
    crypto.getRandomValues(arr);
    return arr[0] % max;
}

function pick(charset) {
    return charset[randomIndex(charset.length)];
}

export function generateSecurePassword(length = MIN_LENGTH) {
    const size = Math.max(length, MIN_LENGTH);
    const chars = [pick(UPPER), pick(LOWER), pick(DIGITS), pick(SYMBOLS)];

    for (let i = chars.length; i < size; i++) {
        chars.push(pick(ALL));
    }

    for (let i = chars.length - 1; i > 0; i--) {
        const j = randomIndex(i + 1);
        [chars[i], chars[j]] = [chars[j], chars[i]];
    }

    return chars.join('');
}

export function validatePasswordStrength(password) {
    if (!password || password.length < MIN_LENGTH) return `A senha deve ter no mínimo ${MIN_LENGTH} caracteres`;
    if (!/[a-z]/.test(password)) return 'A senha deve ter ao menos uma letra minúscula';
    if (!/[A-Z]/.test(password)) return 'A senha deve ter ao menos uma letra maiúscula';
    if (!/[0-9]/.test(password)) return 'A senha deve ter ao menos um número';
    if (!/[^a-zA-Z0-9]/.test(password)) return 'A senha deve ter ao menos um símbolo';
    return null;
}

export function getPasswordRequirements(password) {
    const value = password || '';
    return [
        { key: 'length', label: `Pelo menos ${MIN_LENGTH} caracteres`, met: value.length >= MIN_LENGTH },
        { key: 'lower', label: 'Uma letra minúscula', met: /[a-z]/.test(value) },
        { key: 'upper', label: 'Uma letra maiúscula', met: /[A-Z]/.test(value) },
        { key: 'digit', label: 'Um número', met: /[0-9]/.test(value) },
        { key: 'symbol', label: 'Um símbolo', met: /[^a-zA-Z0-9]/.test(value) }
    ];
}

export function getPasswordStrengthMeta(password) {
    const checks = getPasswordRequirements(password);
    const metCount = checks.filter(item => item.met).length;
    const ratio = checks.length ? metCount / checks.length : 0;
    const normalizedLength = Math.min((password || '').length / 16, 1);
    const score = Math.min(4, Math.round(((ratio * 0.8) + (normalizedLength * 0.2)) * 4));
    const valid = metCount === checks.length;

    let tone = 'bg-red-500';
    if (score >= 4) tone = 'bg-emerald-500';
    else if (score >= 3) tone = 'bg-lime-500';
    else if (score >= 2) tone = 'bg-amber-500';
    else if (score >= 1) tone = 'bg-orange-500';

    return {
        checks,
        score,
        valid,
        width: Math.max(8, ((score + 1) / 5) * 100),
        label: password ? STRENGTH_LABELS[score] : 'Ainda não avaliada',
        tone
    };
}

export const PASSWORD_MIN_LENGTH = MIN_LENGTH;
